<div class="webgl-content" [style.width.px]="this.width">
    <div id="gameContainer" [style.max-width.px]="this.width" height="279"></div>
</div>